import { ApplicationStatus } from 'api/btlApplicationForm/types';
import {
  cloneSectionPagesMap,
  createEmptySectionPagesMap,
  OO_STATUS_CHAIN,
  OO_STATUS_SIDEBAR_CHANGES,
  OO_STATUS_TO_CHAIN_STATUS,
  sortSectionPagesMap,
} from '../config';
import { CaseSidebarItemId, CaseSidebarSection, SectionPagesMap, StatusSidebarChange } from '../types';

function resolveOoChainStatus(status: ApplicationStatus): ApplicationStatus {
  if (OO_STATUS_CHAIN.includes(status)) {
    return status;
  }

  return OO_STATUS_TO_CHAIN_STATUS[status] ?? ApplicationStatus.APPLICATION_SUBMITTED;
}

function appendUniqueItems(items: CaseSidebarItemId[], newItems: CaseSidebarItemId[]): CaseSidebarItemId[] {
  const result = [...items];

  newItems.forEach(item => {
    if (!result.includes(item)) {
      result.push(item);
    }
  });

  return result;
}

function applySidebarChange(pagesBySection: SectionPagesMap, change: StatusSidebarChange): SectionPagesMap {
  const nextPages = cloneSectionPagesMap(pagesBySection);

  if (change.add) {
    (Object.keys(change.add) as CaseSidebarSection[]).forEach(section => {
      const itemsToAdd = change.add?.[section] ?? [];
      nextPages[section] = appendUniqueItems(nextPages[section], itemsToAdd);
    });
  }

  if (change.remove) {
    (Object.keys(nextPages) as CaseSidebarSection[]).forEach(section => {
      nextPages[section] = nextPages[section].filter(item => !change.remove?.includes(item));
    });
  }

  return nextPages;
}

function buildPagesFromChain(status: ApplicationStatus): SectionPagesMap {
  const chainStatus = resolveOoChainStatus(status);
  const chainIndex = OO_STATUS_CHAIN.indexOf(chainStatus);

  if (chainIndex === -1) {
    return createEmptySectionPagesMap();
  }

  let pagesBySection = createEmptySectionPagesMap();

  for (let index = 0; index <= chainIndex; index++) {
    const stepStatus = OO_STATUS_CHAIN[index];
    const change = OO_STATUS_SIDEBAR_CHANGES[stepStatus];

    if (change) {
      pagesBySection = applySidebarChange(pagesBySection, change);
    }
  }

  return sortSectionPagesMap(pagesBySection);
}

export function getAvailableOoPagesForStatus(status: string): SectionPagesMap {
  return buildPagesFromChain(status as ApplicationStatus);
}
